import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../../validations/date-text-field.validator'
import { DataEntryStep1 } from '../../../models/data-entry-step1'
import { ValidatedRadioButtonModel } from '../../../../validations/validated-radio-button-group.component'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { PortalGlobals } from '../../../../portalglobals'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { ValidAgent } from '../../../models/valid-agent'
import { GoodStandingModel } from '../../../../common/models/good-standing-model'
import { StateGateway } from '../../../../common/gateways/state-gateway'
import { ValidatedSelectOptionModel as State } from '../../../../validations/validated-dropdown.component'
import { ValidatedSelectOptionModel } from '../../../../validations/validated-dropdown.component'
import * as moment from 'moment'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { jqxDropDownButtonComponent } from 'jqwidgets-ng/jqxdropdownbutton'
import { stcobModel } from '../../../models/stcob-model'
import { GroupPlanComponent } from '../../common/group-plans.component'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'NEJESingleGroupStep1',
    templateUrl: 'single-group-step1.component.html',
    styleUrls: ['../group-enrollment.component.scss']
})
export class NEJESingleGroupStep1Component implements OnInit {
    @ViewChild('submitBtn') submitBtn!: ElementRef;
    @ViewChild('myGrid') myGrid: jqxGridComponent
    @ViewChild('myDropDownButton') myDropDownButton: jqxDropDownButtonComponent
    @ViewChild(GroupPlanComponent) private childGroup: GroupPlanComponent

    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    dataEntryStep1 = {} as DataEntryStep1
    isValidAgent: boolean
    isFormValid: boolean
    selFaxContactType: string
    //dateofReceiptInvalid: boolean
    //ContactTypeInvalid: boolean
    showMLPAP: boolean
    public optionrbConactType: ValidatedRadioButtonModel[] = []
    optionrbEnrollmentMethod: ValidatedRadioButtonModel[] = []
    optionrbScope: ValidatedRadioButtonModel[] = []
    selEnrollmentMethod: string
    ErrorMessages: any[]
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    agentUserName: string
    hasError: boolean
    EnrollmentMethodError: boolean
    SOAError: boolean
    showGrpText: boolean = false
    showIconLoading: boolean = false
    validAgentModel: ValidAgent
    CUID: string
    AgentID: string
    AdminID: number
    externalUser: boolean = false
    errorMessage: any[]
    IsErrorMesssage: boolean = false
    public loading: boolean = false
    states: State[] = [] as State[]
    planstate: string
    goodStandingValues: GoodStandingModel = {} as GoodStandingModel
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    stcobDetails: stcobModel[] = []
    noGrpPlan: boolean
    showAdminError: boolean = false
    onchangeOrgId: string
    rowNum: number
    baseTitle: string
    source: any = {
        localdata: this.stcobDetails,
        datafields: [
            { name: 'GroupName', type: 'string' },
            { name: 'PrimaryCarrier', type: 'string' },
            { name: 'PrimaryAccount', type: 'string' },
            { name: 'PrimaryGroup', type: 'string' },
            { name: 'SecondaryCarrier', type: 'string' },
            { name: 'SecondaryAccount', type: 'string' },
            { name: 'SecondaryGroup', type: 'string' },
            { name: 'PlanTypeShortName', type: 'string' },
            { name: 'PlanTypeName', type: 'string' },
            { name: 'CAGTypeShortName', type: 'string' },
            { name: 'CAGTypeName', type: 'string' },
            { name: 'GroupFlag', type: 'string' },
            { name: 'OptOutFlag', type: 'string' },
            { name: 'STCOBFlag', type: 'string' },
            { name: 'PBP', type: 'string' },
            { name: 'RxEnrollXREFID', type: 'string' },
            { name: 'CUID', type: 'string' },
            { name: 'CAGID', type: 'string' }
        ],
        datatype: 'array'
    }

    dataAdapter: any = new jqx.dataAdapter(this.source)

    columns: any[] = [
        { text: 'Group Name', datafield: 'GroupName', width: 300 },
        { text: 'CUID', datafield: 'CUID', width: 70 },
        {
            text: 'Primary Carrier',
            datafield: 'PrimaryCarrier',
            width: 80,
            renderer: function (text, align, height) {
                return '<div style="margin: 5px;"><div>Primary</div><div>Carrier</div></div>'
            }
        },
        {
            text: 'Primary Account',
            datafield: 'PrimaryAccount',
            width: 140,
            renderer: function (text, align, height) {
                return '<div style="margin: 5px;"><div>Primary</div><div>Account</div></div>'
            }
        },
        {
            text: 'Primary Group',
            datafield: 'PrimaryGroup',
            width: 110,
            renderer: function (text, align, height) {
                return '<div style="margin: 5px;"><div>Primary</div><div>Group</div></div>'
            }
        },
        {
            text: 'Secondary Carrier',
            datafield: 'SecondaryCarrier',
            width: 90,
            renderer: function (text, align, height) {
                return '<div style="margin: 5px;"><div>Secondary</div><div>Carrier</div></div>'
            }
        },
        {
            text: 'Secondary Account',
            datafield: 'SecondaryAccount',
            width: 130,
            renderer: function (text, align, height) {
                return '<div style="margin: 5px;"><div>Secondary</div><div>Account</div></div>'
            }
        },
        {
            text: 'Secondary Group',
            datafield: 'SecondaryGroup',
            width: 110,
            renderer: function (text, align, height) {
                return '<div style="margin: 5px;"><div>Secondary</div><div>Group</div></div>'
            }
        },
        { text: 'CAGID', datafield: 'CAGID', width: 80 }
    ]

    ready = (): void => {
        this.myGrid.selectrow(0)
    }

    myGridOnRowSelect(event: any): void {
        let args = event.args
        let row = this.myGrid.getrowdata(args.rowindex)
        this.setSTCOBData(row)
        let dropDownContent = '<div style="position: relative; margin-left: 3px; margin-top: 5px;">' + this.enrollment.SINGLEGRPNAME + '</div>'
        this.myDropDownButton.setContent(dropDownContent)

        this.myDropDownButton.close()
    }

    constructor(
        private router: Router,
        private _enrollementGateway: EnrollmentGateway,
        public _global: PortalGlobals,
        private _stateGateway: StateGateway,
        private titleService: Title
    ) {
        this.optionrbConactType.push({ value: 'MLPAP', htmlLabel: 'Mail' }, { value: 'Fax', htmlLabel: 'Fax' })
        // this.optionrbEnrollmentMethod.push({ value: 'Mail', htmlLabel: 'I received a paper application in the mail' }, { value: 'Paper', htmlLabel: 'I completed a paper application in a face to face meeting with the beneficiary' })
        // this.optionrbScope.push({ value: 'ScopeIncluded', htmlLabel: 'A Scope of Appointment is included with this enrollment form' }, { value: 'ScopeNotIncluded', htmlLabel: 'Scope of Appointment was NOT completed because the agent did not have an individual or one-on-one marketing appointment (whether in person, telephonically or otherwise) with the applicant.' })
        //this.dateofReceiptInvalid = false
        this.errorMessage = []
    }

    ngOnDestroy(): void {
        this.titleService.setTitle(this.baseTitle)
    }

    ngOnInit() {

        // Set unique title
        this.baseTitle = this.titleService.getTitle();
        this.titleService.setTitle(this.baseTitle + ' - Single Group Enrollment')

        let isExternalAgent: boolean = false
        //Check if external agent

        //Remove session object
        if (sessionStorage.getItem('EnrollmentCache') != null) {
            sessionStorage.removeItem('EnrollmentCache')
        }

        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        isExternalAgent = this.enrollment.ISEXTERNALAGENT

        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        if (!this.enrollment.ISBACK) {
            if (this._global.currentUser.userProfileName !== undefined && !this._global.currentUser.IsEnoller) {
                this.agentUserName = this._global.currentUser.userProfileName
            } else {
                this.agentUserName = ''
            }
        } else {
            this.agentUserName = this.enrollment.AGENTNAME
        }
        this.dataEntryStep1.AgentName = this.agentUserName

        if (!this.enrollment.ISBACK) {
            this.enrollment = {} as EnrollmentViewModel

            //Remove session object for enrollment cache
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                sessionStorage.removeItem('EnrollmentCache')
            }
        } else {
            this.showIconLoading = true
            this.planstate = this.enrollment.APPST
            this.dataEntryStep1.DateofReceipt = this.enrollment.DATEOFRECEIPT
            this.dataEntryStep1.DataSource = this.enrollment.AGENTDEX
            this.selFaxContactType = this.enrollment.AGENTDEX
            this.showGrpText = true

            this.onContinue()
        }

        //this.enrollment = {} as EnrollmentViewModel
        // this._enrollementGateway.setEnrollmentViewModel(this.enrollment)

        this.enrollment.FORMNAME = 'NEJESINGLEGROUP'
        this.enrollment.ISEXTERNALAGENT = isExternalAgent
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        this.showMLPAP = false
        this.isValidAgent = false
        this.hasError = false
        this.ErrorMessages = [] as any[]
        this.EnrollmentMethodError = false
        this.SOAError = false

        if (User !== undefined) {
            if (this._global.currentUser.IsDataEntrySpecialist || this._global.currentUser.IsDataEntryGroupSpecialist) {
                this.onContinue()
            }
        } else {
            if (this._global.currentUser.IsDataEntrySpecialist || this._global.currentUser.IsDataEntryGroupSpecialist) {
                this.onContinue()
            }
        }
    }

    onContinue(): void {
        this.hasError = false
        this.IsErrorMesssage = false
        this.EnrollmentMethodError = false
        this.SOAError = false
        this.ErrorMessages = [] as any[]

        if (this._global.currentUser.userProfileName === this.dataEntryStep1.AgentName && sessionStorage.getItem('GoodStandingParams') !== null) {
            this.goodStandingValues = JSON.parse(sessionStorage.getItem('GoodStandingParams')!)
            if (this.goodStandingValues !== undefined && this.goodStandingValues != null && !this.goodStandingValues.GoodStandingStatus) {
                var isAgentGoodStanding: boolean = true
                if (!this.goodStandingValues.CurriculumStatus) {
                    this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' has not passed training for ' + this._global.selectedPlanYear + '<br/>')
                    this.hasError = true
                    isAgentGoodStanding = false
                }
                if (!this.goodStandingValues.BackgroundCheckStatus) {
                    this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' background check not approved.<br/>')
                    this.hasError = true
                    isAgentGoodStanding = false
                }
                if (!this._global.currentUser.IsDataEntrySpecialist && !this._global.currentUser.IsDataEntryGroupSpecialist) {
                    if (!this.goodStandingValues.LicenseStatus) {
                        this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' does not have a valid license.<br/>')
                        isAgentGoodStanding = false
                        this.hasError = true
                    }
                }
                if (!isAgentGoodStanding) {
                    return
                }
            }
        }

        this.loading = true
        this._enrollementGateway.isValidAgent(this.dataEntryStep1.AgentName).subscribe(
            (validAgentModel) => {
                let isagentvalid = true

                if (validAgentModel.errorMessage !== undefined && validAgentModel.errorMessage !== null && validAgentModel.errorMessage.length > 0) {
                    this.ErrorMessages.push(validAgentModel.errorMessage)
                    isagentvalid = false
                } else {
                    if (validAgentModel.agentID === 0) {
                        this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' Agent not found')
                        isagentvalid = false
                    }
                    if (validAgentModel.showEnrollmentSourceMS === true) {
                        this.hasError = false
                        this.IsErrorMesssage = false
                        this.EnrollmentMethodError = false
                        this.SOAError = false
                        this.showMLPAP = true
                        this.enrollment.ADMINID = validAgentModel.agentID
                        this.enrollment.AGENTID = String(validAgentModel.agentID)
                        this.enrollment.INSURANCECOMPID = validAgentModel.insuranceCompId
                        this.enrollment.AGENTORGID = validAgentModel.AgentOrgId
                    } else if (validAgentModel.showEnrollmentSource === true) {
                        this.hasError = false
                        this.IsErrorMesssage = false
                        this.EnrollmentMethodError = false
                        this.SOAError = false
                        this.showMLPAP = false
                        this.enrollment.ADMINID = this._global.currentUser.userProfileId
                        this.enrollment.AGENTID = String(validAgentModel.agentID)
                        this.enrollment.INSURANCECOMPID = validAgentModel.insuranceCompId
                        this.enrollment.AGENTORGID = validAgentModel.AgentOrgId
                    }

                    this.externalUser = validAgentModel.IsExternalUser

                    if (validAgentModel.IsCallRepUser === true || validAgentModel.isCallCenterAdmin === true) {
                        this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' is not valid for group enrollment.<br/>')
                        isagentvalid = false
                    }
                }
                //else {
                //    this.ErrorMessages.push(validAgentModel.errorMessage)
                //    isagentvalid = false
                //}
                this.isValidAgent = isagentvalid
                if (!this.isValidAgent) {
                    this.hasError = true
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                    this.hasError = false
                    this.IsErrorMesssage = false
                    this.EnrollmentMethodError = false
                    this.SOAError = false
                    //this.CUID = validAgentModel.CUID
                    this.enrollment.AGENTORGID = validAgentModel.AgentOrgId
                    this.enrollment.AGENTDETAILS = validAgentModel.CurrentUser
                    this.AgentID = String(validAgentModel.agentID)
                    //if (this.CUID === '9110') {
                    //    this.enrollment.STEEREDIND = false
                    //} else {
                    //    this.enrollment.STEEREDIND = true
                    //}
                    this.getState(this.enrollment.AGENTORGID)
                }

                this.loading = false
            },
            (err) => {
                this.loading = false
            }
        )
    }

    formSubmit(): void {
        this.hasError = false
        this.isFormValid = true
        this.IsErrorMesssage = false
        this.EnrollmentMethodError = false
        this.SOAError = false

        this.errorMessage = []

        this.loading = true

        if (this.planstate === undefined || this.planstate === null || this.planstate === '' || this.planstate === '0') {
            this.hasError = false
            this.EnrollmentMethodError = false
            this.IsErrorMesssage = true
            this.errorMessage.push('State cannot be blank')
            this.isFormValid = false
        }
        if (!this.dataEntryStep1.DateofReceipt) {
            //this.dateofReceiptInvalid = true
            this.hasError = false
            this.EnrollmentMethodError = false
            this.IsErrorMesssage = true
            this.errorMessage.push('Date of Receipt cannot be blank')
            this.isFormValid = false
        } else if (this.validateFutureDate(this.dataEntryStep1.DateofReceipt) === false) {
            // this.dateofReceiptInvalid = true
            this.hasError = false
            this.EnrollmentMethodError = false
            this.IsErrorMesssage = true
            this.errorMessage.push('Date of Receipt cannot be future date')
            this.isFormValid = false
        } else {
            //  this.IsErrorMesssage = false
            //this.dateofReceiptInvalid = false
        }
        if (this.dataEntryStep1.DataSource === undefined || this.dataEntryStep1.DataSource === '') {
            //this.ContactTypeInvalid = true
            this.hasError = false
            this.EnrollmentMethodError = false
            this.SOAError = false
            this.errorMessage.push('Enrollment Type is required')
            this.IsErrorMesssage = true
            this.isFormValid = false
        }

        if (this.enrollment.STCOBGROUPNAME === undefined || this.enrollment.STCOBGROUPNAME === '') {
            //this.ContactTypeInvalid = true
            this.hasError = false
            this.EnrollmentMethodError = false
            this.SOAError = false
            this.errorMessage.push('Group Plan is required')
            this.IsErrorMesssage = true
            this.isFormValid = false
        }

        if (this.externalUser) {
            this.enrollment.DEX = 'AGNTP'
        } else {
            this.enrollment.DEX = 'MLPAP'
        }

        this.enrollment.AGENTDEX = this.dataEntryStep1.DataSource
        // this.enrollment.DEX = this.dataEntryStep1.DataSource
        //  this.enrollment.SOA = this.dataEntryStep1.SOA
        this.enrollment.AGENTID = this.AgentID
        this.enrollment.AGENTNAME = this.dataEntryStep1.AgentName
        this.enrollment.USERNAME = this._global.currentUser.userProfileName
        this.enrollment.USERPROFILEID = this._global.currentUser.userProfileId
        this.enrollment.APPST = this.planstate
        this.enrollment.ISSINGLEGROUP = true
        //  this.enrollment.INSURANCECOMPID = this._global.currentUser.
        //this.enrollment.CUID = this.CUID
        this.enrollment.DATEOFRECEIPT = this.dataEntryStep1.DateofReceipt
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (this.isFormValid) {
            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
            this.loading = false
            this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step2'])
        } else {
            this.loading = false
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        this.loading = false
    }
    getState(orgId: number): void {
        let reload: boolean = false

        if (this.enrollment.AGENTNAME != this.dataEntryStep1.AgentName) reload = true

        if (orgId !== undefined && orgId !== 0) {
            this._enrollementGateway.GetAllParentStatesForOrg(orgId).subscribe((states: ValidatedSelectOptionModel[]) => {
                states.unshift({ value: 0, text: '-- Choose One --' })
                // this.mailingstates = states
                this.states = states
                if (this.planstate === undefined || this.planstate === '' || this.planstate === '0' || this.planstate === null) {
                    this.planstate = '0'
                }

                if (this.enrollment.ISBACK && !reload) {
                    this.updateAgentGroup(this.planstate)
                    //this.myGrid.selectrow(this.enrollment.RowIndex)

                    let dropDownContent =
                        '<div style="position: relative; margin-left: 3px; margin-top: 5px;">' + this.enrollment.SINGLEGRPNAME + '</div>'
                    this.myDropDownButton.setContent(dropDownContent)

                    this.myDropDownButton.close()
                }
            })
        }
    }

    validateFutureDate(recdate: Date): Boolean | undefined {
        var currentDate = new Date()
        let receiptdate = moment(recdate).toDate()
        if (receiptdate > currentDate) {
            return false
        }
    }
    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
    onChangeAgentID(): void {
        this.errorMessage = []
        this.hasError = false
        this.IsErrorMesssage = false
        this.isValidAgent = !this.isValidAgent
        this.showIconLoading = false
    }
    setSTCOBData(row: any) {
        this.enrollment.PLANTYPE = row['PBP']
        this.enrollment.STCOBGROUPNAME = row['GroupName']
        this.enrollment.PLANTYPENAME = row['PlanTypeShortName']
        if (row['STCOBFlag'] === 'Y') {
            this.enrollment.GROUP = row['SecondaryGroup']
            this.enrollment.CARRIER = row['SecondaryCarrier']
            this.enrollment.ACCOUNT = row['SecondaryAccount']
            this.enrollment.ISSTCOB = true
            this.enrollment.CHANNELID = row['RxEnrollXREFID']
            this.enrollment.CUID = row['CUID']
        } else {
            this.enrollment.GROUP = row['PrimaryGroup']
            this.enrollment.CARRIER = row['PrimaryCarrier']
            this.enrollment.ACCOUNT = row['PrimaryAccount']
            this.enrollment.ISSTCOB = false
            this.enrollment.CHANNELID = row['RxEnrollXREFID']
            this.enrollment.CUID = row['CUID']
        }
        this.enrollment.SINGLEGRPNAME =
            this.enrollment.STCOBGROUPNAME + '-' + this.enrollment.CARRIER + '-' + this.enrollment.ACCOUNT + '-' + this.enrollment.GROUP
    }

    getSTCOBDetails(orgId: number, state: string) {
        if (!this.showIconLoading) {
            this.loading = true
        }
        this._enrollementGateway.getStcobDetailsByState(orgId, state).subscribe(
            (response: stcobModel[]) => {
                this.stcobDetails = response
                if (this.stcobDetails.length === 0) {
                    this.noGrpPlan = true
                } else {
                    this.noGrpPlan = false
                }
                this.source.localdata = this.stcobDetails
                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
                this.loading = false
                //if (this.enrollment.STCOBGROUPNAME !== undefined && this.enrollment.STCOBGROUPNAME !== null && this.enrollment.STCOBGROUPNAME !== '') {
                //    this.showGroupDetails = true
                //    let dropDownContent = '<div style="position: relative; margin-left: 3px; margin-top: 5px;">' + this.enrollmentViewModel.STCOBGROUPNAME + '</div>';
                //    this.myDropDownButton.setContent(dropDownContent);

                //}
            },
            (err) => {
                this.loading = false
            }
        )
    }
    updateAgentGroup(state: string) {
        this.planstate = state
        this.hasError = false
        this.showAdminError = false
        this.ErrorMessages = [] as any[]

        this.enrollment.APPST = state

        if (
            this.dataEntryStep1.AgentName !== undefined &&
            this.dataEntryStep1.AgentName !== '' &&
            this.dataEntryStep1.AgentName !== null &&
            this.dataEntryStep1.AgentName !== ''
        ) {
            this._enrollementGateway.getOrgIdByUserName(this.dataEntryStep1.AgentName).subscribe(
                (model: string) => {
                    if (model !== undefined && model !== null && model.length !== 0) {
                        this.hasError = false
                        this.onchangeOrgId = model
                        this.enrollment.AGENTORGID = Number(this.onchangeOrgId) //models
                        //this.getSTCOBDetails(Number(this.onchangeOrgId), state)

                        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)

                        if (this.childGroup.IsPlanvisible) {
                            //Refresh list based on State Change
                            this.childGroup.getSTCOBDetails()
                        }

                        this.loading = false
                        return
                    } else {
                        this.ErrorMessages.push('Failed to get User Profile by User Profile Name')
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        this.hasError = true
                        this.loading = false
                    }
                },
                (err) => {
                    this.loading = false
                }
            )
        }
        this.showGrpText = false
        this.showIconLoading = false
    }

    setFocusToSubmitBtn() {
        //if (this.submitBtn) {
        //    this.submitBtn.nativeElement.focus();
        //}

        setTimeout(() => {
            this.submitBtn.nativeElement.focus();
        });
    }
}
